
import { useEffect, useRef, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import AssetMatrixSearchModal from './AssetMatrixSearchModal';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import AssetMatrixDetail from './AssetMatrixDetail';
import UploadPhoto from './UploadPhoto';

const AssetMatrixList = ({history, location}) => {

    const assetMatrixUrl            =   BACKOFFICE_BASE_URL + '/asset_matrix';

    const searchAssetMatrixModalRef =   useRef(null);
    const uploadDocRef              =   useRef(null);

    const [listingLoading, setListingLoading]           =   useState(false);
    const [assetMatrixListing, setAssetMatrixListing]   =   useState([]);
    const [listingMeta, setListingMeta]                 =   useState(null);
    const [formSearchedElems, setFormSearchedElems]     =   useState([]);
    const [permissions, setPermissions]                 =   useState([]);
    const [minimizeTable, setMinimizeTable]             =   useState(false)
    const [amFilterForm, setAMFilterForm]               =   useState({});
    const [assetMatrixId, setAssetMatrixId]             =   useState(null);
    const [refreshDetail, setRefreshDetail] = useState(false);
    const [uploadedAssetMatrixId, setUploadedAssetMatrixId] = useState(null);



    const access_token = useSelector(state => state.auth.access_token);
    const permissionsFromStore = useSelector(state => state.app.acl_info?.permissions || []);

    useEffect(() => {
        loadListingTblData(1);
        if(location?.state?.assetMatrixId) {
            setMinimizeTable(true);
            setAssetMatrixId(location.state.assetMatrixId);
        }
    }, [formSearchedElems]);

    useEffect(() => {
        setPermissions(permissionsFromStore.length > 0 ? permissionsFromStore : []);
    }, [permissionsFromStore]);

    const searchModalHandle = () => {
        if (searchAssetMatrixModalRef.current) {
            searchAssetMatrixModalRef.current.initModalHandler()
        }
    }

    const docModalHandle =   (id)  => {     
         setUploadedAssetMatrixId(id);
        uploadDocRef.current.initModalHandler();
    }
    const handleUploadComplete = () => {
        setRefreshDetail(prev => !prev); 
    }
    const addEditHandle = (id = null) => {
        if(id) {
            history.push('/asset_matrix_add?asset_matrix_id=' + id);
        }else {
            history.push('/asset_matrix_add');
        }
    }
    const viewDetailInit = (id) => {
        setMinimizeTable(true)
        setAssetMatrixId(id);
    }
    const closeViewDetails = () => {
        setMinimizeTable(false)
        setAssetMatrixId(null)
    }

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        const params = { page: page, per_page: 100, ...amFilterForm };
        HttpAPICall.withAthorization('GET', assetMatrixUrl + '/list', access_token, params, {}, (resp) => {
            const respData = resp.data;
            setAssetMatrixListing(respData.data);
            setListingMeta({
                'from'          :   respData.from, 
                'to'            :   respData.to, 
                'total'         :   respData.total, 
                'last_page'     :   respData.last_page, 
                'per_page'      :   respData.per_page, 
                'current_page'  :   respData.current_page
            });
        }).then(() => setListingLoading(false));
    };

    const submitSearchForm = (searchedElems, assetScsSearchForm) => {
        setFormSearchedElems(searchedElems);
        setAMFilterForm(assetScsSearchForm);
    };

    const assetMatrixSearchClear = () => {
        setFormSearchedElems([]);
        setAMFilterForm({});
        searchAssetMatrixModalRef.current.clearSearchForm()
    };

    const assetMatrixJsx = () => {
        return (
            <Ax><div className="page_title row m0">
                <div className={minimizeTable ? "col-2" : "col-12"}>
                    <h3>Asset Matrix List</h3>
                    <div className="text-end mt15">
                        {(!minimizeTable) ?
                            <Ax>
                                {
                                    permissions.includes('asset_matrix_add') &&
                                        <button type="button" className="btn btn-primary" onClick={() => addEditHandle(null)}>New</button>
                                }
                                <button type="button" className="btn btn-secondary" onClick={searchModalHandle} >
                                    <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </Ax>
                            : null}
                    </div>
                </div>
                {
                    minimizeTable
                        ? (
                            <div className="col-10 tap_border_left">
                                <h3>Asset Matrix : {assetMatrixId} </h3>
                                <div className="text-end mt15">
                                    {
                                        permissions.includes('asset_matrix_edit') &&
                                        <>
                                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                            <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                            </button>
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li><Link to={`asset_matrix_add?asset_matrix_id=${ assetMatrixId}`} className="dropdown-item" role="button">Edit</Link></li>
                                                <li><Link className="dropdown-item" role="button" onClick={() => docModalHandle(assetMatrixId)}>Upload Photo</Link></li>
                                            </ul>
                                        </>
                                    }
                                    <button type="button" className="btn btn-secondary" onClick={closeViewDetails}>
                                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                    </button>
                                </div>
                            </div>
                        )
                        : null
                }
            </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', minimizeTable ? 'col-2' : 'col-12'].join(' ')} >{assetMatrixListingJsx()}</div>
                        {minimizeTable ? <div className="col-10 pr4 pl4 "><div style={{ height: "100%" }}>{<AssetMatrixDetail assetMatrixId={assetMatrixId} refreshTrigger={refreshDetail}/>}</div></div> : null}
                    </div>
                </div>
            </Ax>);
    };
    
    const assetMatrixListingJsx = () => {
        return (
            <Ax>
                <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={assetMatrixSearchClear} />
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            {minimizeTable ? <th scope="col" style={{ width: "15%" }}>Name</th>
                                : <Ax>
                                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                                    <th scope="col" style={{ width: "10%" }}>Asset Matrix ID</th>
                                    <th scope="col" style={{ width: "20%" }}>Asset Type Name</th>
                                    <th scope="col" style={{ width: "24%" }}>Manufacturer</th>
                                    <th scope="col" style={{ width: "11%" }}>Model</th>
                                    <th scope="col" style={{ width: "11%" }}>Variant</th>
                                    <th scope="col" style={{ width: "11%" }}>Asset Capacity</th>
                                    <th scope="col" style={{ width: "8%" }}>Action</th>
                                </Ax>}
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading
                            ? (<tr><td colSpan="8"><Loader /></td></tr>)
                            : (assetMatrixListing && assetMatrixListing.length > 0
                                ? (assetMatrixListing.map((item, index) => (
                                    <tr key={index}>
                                        {minimizeTable ? <td><span className='link-primary cursor_pointer' onClick={() => viewDetailInit(item.asset_matrix_unique_id)}>
                                            {item.asset_matrix_unique_id}
                                        </span>
                                        <div className="text-end">
                                            <small>{item.asset_type ? item.asset_type.asset_type_name : "-"}</small>
                                        </div>
                                        </td>
                                            : <Ax>
                                                <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                                <td className='text-center'> <Link
                                                    onClick={() => viewDetailInit(item.asset_matrix_unique_id)}
                                                >{item.asset_matrix_unique_id} </Link></td>
                                                <td>{item.asset_type ? item.asset_type.asset_type_name : "-"}</td>
                                                <td>{item.manufacturer ? item.manufacturer.manufacturer : "-"}</td>
                                                <td>{item.model ? item.model.model : "-"}</td>
                                                <td>{item.variant || "-"}</td>
                                                <td>{item.capacity || "-"}</td>
                                                <td className='text-center'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    { permissions.includes('asset_matrix_edit') &&
                                                        <li onClick={() => addEditHandle(item.asset_matrix_unique_id)}><Link className="dropdown-item" role="button">Edit</Link></li>
                                                    }
                                                    </ul>
                                                </td>
                                            </Ax>}

                                    </tr>
                                )))
                                : (<tr><td colSpan="8" className="text-center">No Records</td></tr>))
                        }
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1)}
                />
            </Ax>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Asset Matrix Listing</title></Helmet>
            <div style={{ overflow: "hidden" }}>
                {assetMatrixJsx()}
                <AssetMatrixSearchModal ref={searchAssetMatrixModalRef} submitSearchFormProp={submitSearchForm}/>
                <UploadPhoto 
                    ref={uploadDocRef} 
                    assetMatrixId={uploadedAssetMatrixId}
                    onUploadComplete={handleUploadComplete}
                />
            </div>
        </ApplicationLayout>
    );
};

export default AssetMatrixList;



